import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
// Self-hosted webfonts. Both families are served from our own origin so a
// blocked or unreachable CDN cannot take out the type. Inter comes from
// npm (already unicode-range split); Pretendard's dynamic subsets are in
// public/fonts and linked from index.html.
import '@fontsource-variable/inter/opsz.css';
import './index.css';
import { AuthProvider } from './contexts/AuthContext';
import { UploadProvider } from './contexts/UploadContext';
import 'leaflet/dist/leaflet.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <UploadProvider>
        <App />
      </UploadProvider>
    </AuthProvider>
  </StrictMode>
);
